<template>
  <div
    :style="!!bgColor ? `background: ${bgColor}` : ''"
    class="ds-hero-logo"
  >
    <div class="ds-container ds-hero-logo__content">
      <DsImageElement
        v-if="logo"
        :image="logo"
        :screen="screen"
        class="ds-hero-logo__img"
      />
    </div>
    <div
      class="ds-hero-logo__border"
      :class="themeBg"
    />
  </div>
</template>
<script setup>
import { DsImageElement } from 'awds'

const { screen } = useScreen()

const props = defineProps({
  logo: {
    type: Object,
    required: true
  },
  theme: {
    type: String,
    default: 'light'
  }
})

const bgColor = computed(() => {
  return props.logo.original?.color || props.logo[screen.value]?.color
})

const themeBg = computed(() => {
  if (props.theme === 'grey') {
    return 'ds-background-color-grey-100'
  }

  if (props.theme === 'dark') {
    return 'ds-background-color-grey-2500' // Support 750
  }

  return 'ds-background-color-white'
})
</script>

<style lang="scss" scoped>
@import 'awds/foundation-vars.scss';
@import 'awds/foundation-mixins.scss';

.ds-hero-logo {
  height: 482px;

  @include screen('medium') {
    height: 660px;
  }

  @include screen('large') {
    height: 564px;
  }

  &__content {
    align-items: center;
    display: flex;
    height: calc(100% - #{$spacing-96});
    justify-content: center;
    position: relative;
  }

  &__img {
    min-width: 260px;
  }

  &__border {
    height: $spacing-96;
    width: 100%;
  }
}
</style>
